import HelpApi from '../common';
import {SaveFaqSearchHistoryResponse} from './type';

export const saveFaqSearchHistory = ({
  searchWord,
}): Promise<SaveFaqSearchHistoryResponse> => {
  return HelpApi.post(
    '/api/set_faq_keyword.php',
    {
      szKeyword: searchWord,
    },
    {},
  );
};
